module.exports = __webpack_public_path__ + "media/images/c-adminSidebarLink/articles-1669b97883c05c242925cfd9da6fdd9e.svg";